(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["montelise-fluid-home"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-mfh-video]').forEach((video) => {
      const play = () => video.play().catch(() => {});
      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(play, { timeout: 2200 });
      } else {
        window.setTimeout(play, 1600);
      }
    });

    const videoTarget = document.querySelector('[data-mfh-video-area]');
    document.querySelector('[data-mfh-scroll-video]')?.addEventListener('click', () => {
      videoTarget?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    const reelItems = Array.from(document.querySelectorAll('[data-mfh-reel-item]'));
    const reelLightbox = document.querySelector('[data-mfh-reel-lightbox]');
    const reelMain = document.querySelector('[data-mfh-reel-main]');
    const reelTitle = document.querySelector('[data-mfh-reel-title]');
    const reelLink = document.querySelector('[data-mfh-reel-link]');
    const reelPrevSide = document.querySelector('[data-mfh-reel-side="prev"]');
    const reelNextSide = document.querySelector('[data-mfh-reel-side="next"]');
    let reelIndex = 0;

    const cloneReelMedia = (item, autoplay) => {
      const tiktokId = item.getAttribute('data-mfh-tiktok-id');
      const localVideoSrc = item.getAttribute('data-mfh-video-src');
      const localVideoPoster = item.getAttribute('data-mfh-video-poster');
      if (tiktokId && autoplay) {
        const frame = document.createElement('iframe');
        frame.src = `https://www.tiktok.com/embed/v2/${tiktokId}`;
        frame.title = item.getAttribute('aria-label') || 'Montelise TikTok video';
        frame.allow = 'encrypted-media; fullscreen; picture-in-picture';
        frame.allowFullscreen = true;
        return frame;
      }
      if (localVideoSrc && autoplay) {
        const video = document.createElement('video');
        video.src = localVideoSrc;
        if (localVideoPoster) video.poster = localVideoPoster;
        video.controls = true;
        video.muted = true;
        video.loop = true;
        video.playsInline = true;
        window.setTimeout(() => video.play().catch(() => {}), 80);
        return video;

      }
      const sourceVideo = item.querySelector('video');
      const sourceImage = item.querySelector('img');
      if (sourceVideo) {
        const video = sourceVideo.cloneNode(true);
        video.controls = autoplay;
        video.muted = true;
        video.loop = true;
        video.playsInline = true;
        video.removeAttribute('data-mfh-video');
        if (autoplay) window.setTimeout(() => video.play().catch(() => {}), 80);
        return video;
      }
      if (sourceImage) {
        const image = sourceImage.cloneNode(true);
        image.loading = 'eager';
        return image;
      }
      return document.createElement('span');
    };

    const renderReel = (index) => {
      if (!reelLightbox || !reelMain || !reelItems.length) return;
      reelIndex = (index + reelItems.length) % reelItems.length;
      const item = reelItems[reelIndex];
      const prevItem = reelItems[(reelIndex - 1 + reelItems.length) % reelItems.length];
      const nextItem = reelItems[(reelIndex + 1) % reelItems.length];
      reelMain.replaceChildren(cloneReelMedia(item, true));
      reelPrevSide?.replaceChildren(cloneReelMedia(prevItem, false));
      reelNextSide?.replaceChildren(cloneReelMedia(nextItem, false));
      if (reelTitle) reelTitle.textContent = item.querySelector('strong')?.textContent || item.getAttribute('aria-label') || '';
      if (reelLink) reelLink.href = item.href;
    };

    const openReel = (index) => {
      if (!reelLightbox) return;
      renderReel(index);
      reelLightbox.classList.add('is-visible');
      reelLightbox.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
    };

    const closeReel = () => {
      if (!reelLightbox) return;
      reelLightbox.classList.remove('is-visible');
      reelLightbox.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
      reelMain?.replaceChildren();
      reelPrevSide?.replaceChildren();
      reelNextSide?.replaceChildren();
    };

    reelItems.forEach((item, index) => {
      item.addEventListener('click', (event) => {
        event.preventDefault();
        openReel(index);
      });
    });
    document.querySelector('[data-mfh-reel-close]')?.addEventListener('click', closeReel);
    document.querySelector('[data-mfh-reel-prev]')?.addEventListener('click', () => renderReel(reelIndex - 1));
    document.querySelector('[data-mfh-reel-next]')?.addEventListener('click', () => renderReel(reelIndex + 1));
    reelLightbox?.addEventListener('click', (event) => { if (event.target === reelLightbox) closeReel(); });
    document.addEventListener('keydown', (event) => {
      if (!reelLightbox?.classList.contains('is-visible')) return;
      if (event.key === 'Escape') closeReel();
      if (event.key === 'ArrowLeft') renderReel(reelIndex - 1);
      if (event.key === 'ArrowRight') renderReel(reelIndex + 1);
    });

    const popup = document.querySelector('[data-mfh-popup]');
    if (!popup) return;
    const key = 'mfh_welcome_popup_until';
    const day = 24 * 60 * 60 * 1000;
    const getUntil = () => {
      try { return Number(window.localStorage.getItem(key) || 0); } catch (error) { return 0; }
    };
    const setUntil = (days) => {
      try { window.localStorage.setItem(key, String(Date.now() + days * day)); } catch (error) {}
    };
    const open = () => {

      if (getUntil() > Date.now()) return;
      popup.classList.add('is-visible');
      popup.setAttribute('aria-hidden', 'false');
    };
    const close = () => {
      popup.classList.remove('is-visible');
      popup.setAttribute('aria-hidden', 'true');
      setUntil(14);
    };
    popup.querySelectorAll('[data-mfh-close]').forEach((button) => button.addEventListener('click', close));
    popup.addEventListener('click', (event) => { if (event.target === popup) close(); });
    document.addEventListener('keydown', (event) => { if (event.key === 'Escape' && popup.classList.contains('is-visible')) close(); });
    popup.querySelector('form')?.addEventListener('submit', () => setUntil(90));
    if (window.location.search.includes('customer_posted=true')) {
      window.setTimeout(open, 400);
      return;
    }
    window.setTimeout(open, 12000);
    document.addEventListener('mouseleave', (event) => { if (event.clientY <= 0) open(); }, { once: true });
  })();

  } catch(e) { console.error(e); }
})();
})();
